<div class="flex-center">
  <div class="contentWidth">
    <div style="height: calc(90vh - 100px); overflow-y: auto;">
      <form [formGroup]="PSForm" autocomplete="off">
        <ng-container formArrayName="PSRows">
          <table #objTable
            mat-table
            matSort
            [dataSource]="dataSource"
            class="table-add-butt-header-orange mat-elevation-z8 mat-table-custom">

            <ng-container matColumnDef="headertitle">
              <th class="title-col" mat-header-cell *matHeaderCellDef colspan="5">
                <div class="pull-left">
                  <h4>Peripheral Software Versions</h4>
                </div>
              </th>
            </ng-container>
            <ng-container matColumnDef="headeraddbutton">
              <th class="butt-col" mat-header-cell *matHeaderCellDef>
                <div class="OrangeButton">
                  <button mat-raised-button (click)="addNewRow()"
                    matTooltip="Add Version" class="button-color-fix pull-right">
                    <mat-icon class="icon-color-fix icon-padding-fix">add_box</mat-icon>
                  </button>
                </div>
              </th>
            </ng-container>

            <!-- Version Column -->
            <ng-container matColumnDef="peripheralSoftwareVersion">
              <th mat-header-cell *matHeaderCellDef style="width:15%" mat-sort-header="peripheralSoftwareVersion">Version</th>
              <td mat-cell *matCellDef="let element; let i = index" style="width:15%">
                @if (!element?.isNewRow) {
                  <div [innerHTML]="element.peripheralSoftwareVersion"></div>
                }
                @if (element?.isNewRow) {
                  <mat-form-field style="width: 100%">
                    <input matInput type="text"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="element.peripheralSoftwareVersion"
                      maxlength="50"
                      matTooltip="Max 50 characters"
                      (keydown)="checkInput($event)" />
                    </mat-form-field>
                  }
                </td>
              </ng-container>

              <!-- Family Code Column -->
              <ng-container matColumnDef="familycode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="familycode" style="width:10%">Family Code</th>
                <td mat-cell *matCellDef="let element" style="width:10%">
                  @if (element.isEditable) {
                    <div [innerHTML]="getFamilyCodeText(element.familyCodeId)"></div>
                  } @else {
                    <mat-form-field floatLabel="auto">
                      <mat-select [(ngModel)]="element.familyCodeId" style="min-width: 200px; color:red" [ngModelOptions]="{standalone: true}">
                        <mat-option [value]="-1" [disabled]="true">Select</mat-option>
                        @for (fc of availableFamilyCodes; track fc) {
                          <mat-option [value]="fc.familyCodeId">
                            {{getFamilyCodeText(fc.familyCodeId)}}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                </td>
              </ng-container>

              <!-- Release Date Column -->
              <ng-container matColumnDef="releaseDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="releaseDate" style="width:10%">Release UTC Date</th>
                <td mat-cell *matCellDef="let element; let i = index" style="width:10%">
                  @if (element.isEditable) {
                    <div [innerHTML]="datePipe.transform(element.releaseDate,'yyyy-MM-dd')"></div>
                  } @else {
                    <mat-form-field>
                      <input matInput [matDatepicker]="picker"
                        [ngModelOptions]="{standalone: true}"
                        [(ngModel)]="element.releaseDate"
                        (dateChange)="getDateUTCChange(element, $event)" />
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    }
                  </td>
                </ng-container>

                <!-- Comment Column -->
                <ng-container matColumnDef="comment">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="comment" style="width:20%">Comment</th>
                  <td mat-cell *matCellDef="let element; let i = index" style="width:20%">
                                <textareaoverlay [inputControls]="{
                                                         isOpenOverlay: element.isOpenOverlay,
                                                         textAreaId: element.textAreaId,
                                                         isEditable: !element.isEditable,
                                                         maxCommentLength: element.maxCommentLength,
                                                         comment: element.comment
                                                     }"
                      [customSpanClass]="{'alternative2': !element?.isEditable}"
                      (commentChange)="onCommentChange($event.comment, element)">
                    </textareaoverlay>
                  </td>
                </ng-container>

                <!-- Compatibility Column -->
                <ng-container matColumnDef="compatibility">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="compatibility" style="width:20%">
                    Compatibility GCSW - GR
                  </th>
                  <td mat-cell *matCellDef="let element" style="width:20%; position:relative;">
                    @if (element.isEditable) {
                      <mat-chip-set>
                        @for (comp of element.compatibilities; track comp) {
                          <mat-chip>{{ comp.globalControllerGroupName }}</mat-chip>
                        }
                      </mat-chip-set>
                    } @else {
                      <mat-form-field style="width:100%; position:relative;" floatLabel="auto">
                        <mat-chip-grid #chipList>
                          @for (comp of element.compatibilities; track comp; let j = $index) {
                            <mat-chip-row
                              [removable]="true"
                              (removed)="removeCompatibility(element, j)">
                              {{ comp.globalControllerGroupName }}
                              <mat-icon matChipRemove>cancel</mat-icon>
                            </mat-chip-row>
                          }
                          <input placeholder=""
                            [matChipInputFor]="chipList"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="false"
                            [matAutocomplete]="auto"
                            matAutocompleteTrigger
                            [(ngModel)]="compatibilityInput[element.peripheralSoftwareVersionID]"
                            [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="filterCompatibilityOptions($event, element)"
                            (matChipInputTokenEnd)="addCompatibilityFromInput($event, element)"
                            (focus)="openAutocomplete(element)"
                            style="min-width: 80px; width: auto; flex: 1 1 80px;">
                          </mat-chip-grid>
                          <mat-icon class="search-suffix-fixed">search</mat-icon>
                          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedCompatibility($event, element)">
                            @for (option of compatibilityGroupsFiltered[element.peripheralSoftwareVersionID]; track option) {
                              <mat-option [value]="option.globalControllerGroupId">
                                {{ option.globalControllerGroupName }}
                              </mat-option>
                            }
                          </mat-autocomplete>
                        </mat-form-field>
                      }
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef style="width:10%"></th>
                    <td mat-cell
                      *matCellDef="let element; let i = index" style="width:10%">

                      <button mat-icon-button
                        matTooltip="Show details"
                        color="warn"
                        (click)="showDetails(getPSRowFormGroup(element.peripheralSoftwareVersionID), element.peripheralSoftwareVersionID)">
                        <mat-icon class="actionButtons">remove_red_eye</mat-icon>
                      </button>

                      @if (!element.isEditable) {
                        <button mat-icon-button
                          matTooltip="Cancel Changes"
                          color="warn"
                          (click)="resetRowByID(element.peripheralSoftwareVersionID, element)">
                          <mat-icon class="actionButtons">rotate_left</mat-icon>
                        </button>
                      }

                      @if (element.isEditable) {
                        <button mat-icon-button
                          matTooltip="Edit"
                          color="primary"
                          (click)="editRowByID(element.peripheralSoftwareVersionID)">
                          <mat-icon class="actionButtons">edit</mat-icon>
                        </button>
                      }
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="savefooter">
                    <th mat-footer-cell *matFooterCellDef colspan="6">
                      <div class="OrangeButton">
                        <button mat-raised-button type="submit" (click)="onSave()"
                          [disabled]="!anyChange()"
                          [matTooltip]="anyChange()? 'Save changes' : 'Save disabled'"
                          class="button-color-fix pull-right">
                          Save
                          <mat-icon style="color:white !important" class="icon-color-fix">save</mat-icon>
                        </button>
                      </div>
                    </th>

                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="['headertitle', 'headeraddbutton']; sticky: true" class="stickyTopz100"></tr>
                  <tr class="col-headers" mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
                  <tr mat-row *matRowDef="let row; let i = index; columns: columnsToDisplay;" [class.alternative2]="!row.isEditable"></tr>
                  <tr mat-footer-row *matFooterRowDef="['savefooter']; sticky: true"></tr>
                </table>
              </ng-container>
            </form>
          </div>
        </div>
      </div>
